import { render } from "./BasicTemplate2.vue?vue&type=template&id=11ee0d3a&scoped=true"
import script from "./BasicTemplate2.vue?vue&type=script&lang=js"
export * from "./BasicTemplate2.vue?vue&type=script&lang=js"

import "./BasicTemplate2.vue?vue&type=style&index=0&id=11ee0d3a&scoped=true&lang=css"

import exportComponent from "C:\\tapfactor-max\\tapfactor\\frontend_tapfactor\\tapfactorprofile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ee0d3a"]])

export default __exports__